import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CmsService } from "@spartacus/core";
import { CmsComponentData, MediaComponent } from "@spartacus/storefront";
import { Observable, Subscription } from "rxjs";
import { CheckoutFlowService } from "src/app/knbr-dual-checkout/checkout-flow-service";
import { EditCartConfirmationModalComponent } from "src/app/knbr-dual-checkout/edit-cart-confirmation-modal/edit-cart-confirmation-modal.component";
import { AsyncPipe } from "@angular/common";

@Component({
    selector: "kn-br-banner",
    templateUrl: "./kn-br-banner.component.html",
    styleUrls: ["./kn-br-banner.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MediaComponent, AsyncPipe],
})
export class KnBrResponsiveBannerComponent implements OnInit, OnDestroy {
  componentData$: Observable<any> = this.componentData.data$;
  bannerData$: Observable<any>;
  pagetemplateName;
  allSubscriptions = new Subscription();
  shouldRender: boolean;
  displayModal = false;
  modalRef: any;

  constructor(
    protected componentData: CmsComponentData<any>,
    protected checkoutflowService: CheckoutFlowService,
    private modalService: NgbModal,
    private cmsService: CmsService
  ) {
    // this.bannerData$ = this.cmsService.getComponentData("CwtBannerComponent");
    // this.allSubscriptions.add(
    //   this.cmsService.getCurrentPage().subscribe((pageData) => {
    //     this.pagetemplateName = pageData?.template;
    //   })
    // );
  }
  ngOnInit(): void {
    this.allSubscriptions.add(
      this.checkoutflowService.cartCreditInfo$.subscribe((showModal) => {
        this.displayModal = showModal;
      })
    );
    this.componentData$.subscribe((data) => {
      if (data?.uid === "CwtLoginBackgroundComponent") {
        this.shouldRender = false;
        return;
      }
      {
        this.shouldRender = true;
      }
    });
  }

  onLinkClick(event: Event, url: string | null) {
    if (this.displayModal) {
      event.preventDefault();
      event.stopPropagation();
      this.modalRef = this.modalService.open(
        EditCartConfirmationModalComponent,
        {
          centered: true,
          size: "lg",
        }
      );
      this.modalRef.componentInstance.destinationUrl = url;
    }
  }

  ngOnDestroy(): void {
    this.allSubscriptions?.unsubscribe();
  }
}
